import { connect } from "react-redux";
import PaymentInvoiceAdvance from "./paymentInvoiceAdvance";
import { bindActionCreators } from "redux";
import { getVendorRequestSubmit,getPaymentRequestDetails,getVendorPo,saveVendorPayment, getVendorDepartment, addVendorAdvance } from "services/redux/sales/vendorPortal/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";


import {
  fetchZones,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  getVendorDetails: state.vendorPortalReducer.vendorPaymentAdd,
  poDetail: state.vendorPortalReducer.poDetail,
  vendorDepartmentList: state.vendorPortalReducer.vendorDepartmentList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchZones,
      getVendorRequestSubmit,
      getPaymentRequestDetails,
      getVendorPo,
      saveVendorPayment,
      documentUploadUrl,
      getVendorDepartment,
      addVendorAdvance
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentInvoiceAdvance);
